enum AddressUses {
	None,
	Household = 1,
	Business = Household << 1,
	All = 2147483647
}

export default AddressUses;
